import { createFileRoute, Outlet, Navigate } from "@tanstack/react-router";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Área privada | Mine Class" },
      { name: "description", content: "Área privada de Mine Class — acceso restringido a usuarios autenticados." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AuthGate,
});

function AuthGate() {
  const { loading, user, isApproved, isSuperadmin, profile } = useSession();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[var(--color-on-surface-variant)]">
        Cargando...
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" />;

  // Wait for profile/roles to load before deciding
  if (!profile) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[var(--color-on-surface-variant)]">
        Verificando permisos...
      </div>
    );
  }

  if (!isApproved) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--color-surface-container-low)] px-4">
        <div className="max-w-md bg-white border border-[var(--color-outline-variant)] p-8 text-center">
          <h1 className="text-xl font-bold text-[var(--color-brand-purple)]">Cuenta pendiente</h1>
          <p className="text-sm text-[var(--color-on-surface-variant)] mt-3">
            Tu cuenta <strong>{profile?.email}</strong> aún no ha sido aprobada por un superadministrador.
          </p>
        </div>
      </div>
    );
  }

  if (!isSuperadmin) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
}
